import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMarketAreaQuickInfo extends Layout {
    buttonDispatchZoneCode: Button;
    panelMarketAreaQuickInfo: Panel;
    sourceMarketArea: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
